import Mention from '@tiptap/extension-mention';
import { AVATAR_MENTION_COLOR_MAP } from '@/lib/colorsMap';

export const CustomMention = Mention.extend({
    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('data-user-id'),
                renderHTML: attributes => ({
                    'data-user-id': attributes.id,
                }),
            },
            label: {
                default: null,
                parseHTML: element => element.getAttribute('data-user-name'),
                renderHTML: attributes => ({
                    'data-user-name': attributes.label,
                }),
            },
            avatarColor: {
                default: 'bg-neutral-600',
                parseHTML: element => element.getAttribute('data-user-avatarColor'),
                renderHTML: attributes => ({
                    'data-user-avatarColor': attributes.avatarColor,
                }),
            },
        }
    },
});

export const getMentionConfig = (axiosInstance, organizationSlug) => ({
    HTMLAttributes: {
        class: 'mention'
    },
    renderHTML({ node }) {
        const mentionClasses = AVATAR_MENTION_COLOR_MAP[node.attrs.avatarColor] || AVATAR_MENTION_COLOR_MAP['bg-neutral-600'];
        
        return [
            'span',
            {
                'class': `inline-flex items-center rounded-md ${mentionClasses} px-1.5 py-0.5 text-sm font-medium`,
                'data-type': 'mention',
                'data-user-id': node.attrs.id,
                'data-user-name': node.attrs.label,
                'data-user-avatarColor': node.attrs.avatarColor
            },
            [
                'span',
                {
                    'class': 'mention-name'
                },
                `@${node.attrs.label}`
            ]
        ];
    },
    renderText({ node }) {
        return `@${node.attrs.label}`;
    }
}); 